import { get } from 'lodash';
import { NavigateFunction, Location } from 'react-router-dom';

import { CLEAN_BOUNDARY_ERROR } from '../core/constants';

/**
 * Check in the state of location object if the error kept in ErrorBoundary component
 * has to be cleaned.
 * @param {Location} location - router location.
 * @returns {boolean}
 */
export function shouldCleanErrorBoundary({ state }: Location): boolean {
  return get(state, CLEAN_BOUNDARY_ERROR) === true;
}

/**
 * Redirect to the specific path passed as argument and adds into location state the
 * flag to clean the error boundary component in case of existing an error.
 * @param {NavigateFunction} navigate
 * @param {string} pathname
 * @returns Function which redirects to the pathname passed as parameter.
 */
export const cleanErrorAndGoToPath = (navigate: NavigateFunction, pathname: string) => (
  event: React.MouseEvent<HTMLElement>
) => {
  event.stopPropagation();
  navigate(pathname, {
    state: {
      [CLEAN_BOUNDARY_ERROR]: true
    }
  });
};
